const fileTypes = {
    locationFiles: {
        fileCategoryType: 'merchantLocationFileType',
        fileTypes: ['photo', 'logo', 'header_image'],
    },
    default: {
        fileCategoryType: 'merchantFileType',
        fileTypes: ['logo', 'header_image'],
    },
};

export const getFileCategoryType = (fieldName) => {
    return fileTypes[fieldName]?.fileCategoryType || fileTypes.default.fileCategoryType;
};
export const getFileTypes = (fieldName) => {
    return fileTypes[fieldName]?.fileTypes || fileTypes.default.fileTypes;
};
